var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirstGoustoBoxFree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 228.6 200",
    style: {
      enableBackground: "new 0 0 228.6 200"
    },
    xmlSpace: "preserve",
    width: "3rem",
    height: "3rem",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0 { fill: #333d45; }\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M228.6,119c0,2.7-2.1,4.8-4.8,4.8h-14.3v61.9c0,7.9-6.4,14.3-14.3,14.3H33.3c-7.9,0-14.3-6.4-14.3-14.3v-61.9 H4.8c-2.7,0-4.8-2.1-4.8-4.8V71.4c0-2.7,2.1-4.8,4.8-4.8h65.5c-18.5,0-33.3-14.9-33.3-33.3S51.8,0,70.2,0c10,0,19.2,4.2,25,11.5 l19,24.6l19-24.6c5.8-7.3,15-11.5,25-11.5c18.5,0,33.3,14.9,33.3,33.3s-14.9,33.3-33.3,33.3h65.5c2.7,0,4.8,2.1,4.8,4.8V119z  M99.3,47.6l-18.7-24c-1.6-1.9-5.2-4.6-10.3-4.6C62.4,19,56,25.4,56,33.3c0,7.9,6.4,14.3,14.3,14.3H99.3z M138.1,164.9V95.2V66.7 H90.5v28.6v69.6v8.3c0,5.2,4.3,7.7,9.5,7.7h28.6c5.2,0,9.5-2.5,9.5-7.7V164.9z M158.3,19c-5.1,0-8.6,2.7-10.3,4.6l-18.6,24h28.9 c7.9,0,14.3-6.4,14.3-14.3C172.6,25.4,166.2,19,158.3,19z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstGoustoBoxFree);
export default __webpack_public_path__ + "static/media/First_Gousto_Box_Free.9af0a11e21a498010a8c8f1c60f5b776.svg";
export { ForwardRef as ReactComponent };